// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { MobileProgramming } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { icon1: MobileProgramming };

// ==============================|| MENU ITEMS - category ||============================== //

const AiLessonPlanner: NavItemType = {
  id: 'AiLesson',
  //   title: <FormattedMessage id="AiLesson" />,
  type: 'group',
  icon: icons.icon1,
  name: 'AiLesson',
  children: [
    {
      icon: icons.icon1,
      id: 'AiLesson',
      title: <FormattedMessage id="Ai Lesson Planner" />,
      type: 'item',
      url: '/aiLesson'
    }
  ]
};

export default AiLessonPlanner;
